/**
 * @file product-images.tsx
 * @module app/modules/uProcure/products/product-images
 * @description Implements the product images interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Card } from 'react-bootstrap';
import CloseSVG from '../../../../_admin/assets/media/svg_uTrade/cross-rounded-gray.svg';
import UploadImgWhite from '../../../../_admin/assets/media/svg_uTrade/upload-img-white.svg';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { fileValidation } from '../../../../Global/fileValidation';
// import Validations from '../../../utils/validations';
// import { error } from '../../../Global/toast';
const ProductImages = (props: any) => {
  const [dragId, setDragId] = useState();
  const [generalData, setGeneralData] = useState<any>(props.generalData);
  const [generalDataValidation, setGeneralDataValidation] = useState<any>(
    props.validations
  );
  useEffect(() => {
    props.onGeneralDataChange(generalData);
  }, [generalData, props]);
  useEffect(() => {
    props.onValidationChange(generalDataValidation);
  }, [generalDataValidation]);
  useEffect(() => {}, [props.validations]);
  const handleImage = async (event: any, index: number) => {
    const selectedFiles = event.target.files;
    let temp = { ...generalData };
    if (!selectedFiles) return;
    else {
      let temp2 = JSON.parse(JSON.stringify(temp));
      let generalValidationTemp = JSON.parse(
        JSON.stringify({ ...generalDataValidation })
      );
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        if (fileValidation(selectedFiles?.[i])) {
          await toBase64(selectedFiles?.[i]).then((data) => {
            temp2.combinations[index].dimensions.images.push({
              url: URL.createObjectURL(selectedFiles?.[i]),
              obj: data,
            });
          });
        }
      }
      let imagesTemp: any = [];
      temp2.combinations[index].dimensions.images.map(
        (val: any, index: number) => {
          imagesTemp.push({ ...val, id: index, order: index });
        }
      );
      temp2.combinations[index].dimensions.images = imagesTemp;
      await setGeneralData(temp2);
      generalValidationTemp.combinations[index].dimensions.images = false;
      await setGeneralDataValidation(generalValidationTemp);
    }
  };
  const toBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  // const handleDrag = (ev: any) => {
  //   setDragId(ev.currentTarget.id);
  // };
  const handleRemoveImage = (index: number, id: number) => {
    let temp = { ...generalData };
    let generalValidationTemp = { ...generalDataValidation };
    // let data = temp.combinations[index];
    // let updatedImage = data.dimensions.images.filter(
    //   (e: any, i: number) => i !== productIndex
    // );
    // let updatedImageReader = data.dimensions.imageReader.filter(
    //   (e: any, i: number) => i !== productIndex
    // );
    // if (!updatedImage.length) {
    //   generalValidationTemp.combinations[index].dimensions.images = true;
    // }
    // data.dimensions.images = updatedImage;
    // data.dimensions.imageReader = updatedImageReader;
    if (temp.combinations[index].dimensions.images.length > 0) {
      const filterImages = temp.combinations[index].dimensions.images.filter(
        (image: any) => image.id !== id
      );
      temp.combinations[index].dimensions.images = filterImages;
      if (!filterImages.length) {
        generalValidationTemp.combinations[index].dimensions.images = true;
      }
    }
    setGeneralDataValidation(generalValidationTemp);
    setGeneralData(temp);
  };
  const handleDrag = async (ev: any) => {
    await setDragId(ev.currentTarget.id.toString());
  };
  const handleDrop = async (event: any, index: number, imageIndex: number) => {
    let temp = JSON.parse(JSON.stringify({ ...generalData }));
    const dragImage = temp.combinations[index].dimensions.images.find(
      (image: any) => image.id == dragId
    );
    const dropImage = temp.combinations[index].dimensions.images.find(
      (image: any) => image.id == event.currentTarget.id
    );
    const arr = moveItem(dragImage.id - 1, dropImage.id - 1, index);
    await setGeneralData(arr);
  };
  const moveItem = (from: any, to: any, index: number) => {
    let temp = JSON.parse(JSON.stringify({ ...generalData }));
    const f = temp.combinations[index].dimensions.images.splice(from, 1)[0];
    temp.combinations[index].dimensions.images.splice(to, 0, f);
    return temp;
  };
  return (
    <>
      {generalData &&
        generalData.combinations.map((val: any, index: number) => {
          return (
            <>
              {val.dimensions.product[0].isChecked ||
              val.dimensions.product[1].isChecked ||
              val.dimensions.product[2].isChecked ||
              val.dimensions.product[3].isChecked ? (
                <Card className="py-2 bg-light border mb-8">
                  <Card.Header className="border-bottom-0">
                    <Card.Title className="fs-22 fw-bolder">
                      {val.title.replace(/\s*\)\s*/g, ')')}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body className="pt-0">
                    <div className="d-flex flex-wrap flex-row flex-start gap-lg-6 gap-4">
                      <div>
                        <div>
                          <div
                            className={clsx(
                              'upload-btn-wrapper',
                              generalDataValidation.combinations[index]
                                .dimensions &&
                                generalDataValidation.combinations[index]
                                  .dimensions.images
                                ? ' border border-danger'
                                : ''
                            )}
                          >
                            <div className="symbol symbol-125px symbol-md-170px">
                              <img
                                src={UploadImgWhite}
                                alt=""
                              />
                            </div>
                            <input
                              className="w-100 h-100"
                              type="file"
                              name="myfile"
                              multiple
                              accept="image/png, image/jpeg"
                              id={val.title}
                              onChange={(event) => {
                                handleImage(event, index);
                              }}
                              disabled={props.loading}
                            />
                          </div>
                        </div>
                        <span className="text-gray text-italic">{`Image dimensions:-(700x700px)`}</span>
                      </div>
                      {val.dimensions.images
                        // .sort((a: any, b: any) => a.order - b.order)
                        .map((imageVal: any, imageIndex: number) => {
                          return (
                            <div>
                              <div
                                className="position-relative"
                                draggable={true}
                                id={imageVal.id}
                                onDragOver={(ev) => ev.preventDefault()}
                                onDragStart={handleDrag}
                                onDrop={(event) => {
                                  handleDrop(event, index, imageIndex);
                                }}
                              >
                                <div className="symbol symbol-125px symbol-md-168px bg-body">
                                  <img
                                    className="img-fluid p-2 object-fit-contain"
                                    src={imageVal.url}
                                    alt=""
                                  />
                                </div>
                                {!props.loading ? (
                                  <img
                                    className="img-fluid close-top-2"
                                    src={CloseSVG}
                                    alt=""
                                    onClick={() => {
                                      handleRemoveImage(index, imageVal.id);
                                    }}
                                  />
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </Card.Body>
                </Card>
              ) : (
                <></>
              )}
            </>
          );
        })}
    </>
  );
};
export default ProductImages;
